import React, { FC } from 'react';

import { PaymentType, Transaction as TransactionModel, translateAccountType } from 'api-client';
import { CustomLink, Money } from 'components/common';
import { MoneyMode } from 'components/common/utils/Money/Money';
import { formatDate } from 'formatters';
import { useTransactionsTranslation } from 'hooks/useTransactionsTranslation';
import { cn, RouteDictionary } from 'utils';

import styles from './TransactionMobileCard.module.scss';

interface Props {
  transaction: TransactionModel;
}

const TransactionMobileCard: FC<Props> = ({ transaction }) => {
  const translateTransaction = useTransactionsTranslation();
  const isIncome = transaction.paymentType !== PaymentType.DEBIT;

  return (
    <article className={styles.card}>
      <div className={styles.header}>
        {transaction.projectName === undefined ? (
          <div className={styles.projectName}>Проект не указан</div>
        ) : (
          <CustomLink
            to={RouteDictionary.DETAILED_PROJECT}
            params={{ uuid: transaction.projectUuid }}
            className={styles.projectLink}
          >
            <div className={styles.projectName}>{transaction.projectName[0].text}</div>
          </CustomLink>
        )}
        <div className={cn(styles.money, isIncome && styles.income)}>
          <span>{isIncome ? '+' : '-'}</span>
          <Money money={transaction.money} mode={isIncome ? MoneyMode.WRITE_OFF : undefined} />
        </div>
      </div>

      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Дата</span>
          <span className={styles.metricValue}>{formatDate(transaction.date)}</span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Тип транзакции</span>
          <span className={styles.metricValue}>
            {translateTransaction(transaction.transactionType).text}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Тип счета</span>
          <span className={styles.metricValue}>
            {translateAccountType(transaction.accountType)}
          </span>
        </div>
      </div>

      <div className={styles.metric}>
        <span className={styles.metricLabel}>Пояснение</span>
        <span className={styles.description}>
          {translateTransaction(transaction.transactionType).description}
        </span>
      </div>
    </article>
  );
};

export default TransactionMobileCard;
